export const useStyles = (theme) => ({
  root: { padding: 5, display: "flex", alignItems: "center" },
});
